// extracted by mini-css-extract-plugin
export default {"wrapper":"PageNotFound_wrapper__if6wX","text":"PageNotFound_text__nGedg"};